import React, { useState } from "react";
import styled from "@emotion/styled";

import { Card, CardHeader, CardStyledInformationContent } from "../Card/Card";
import { UnderlinedButtonStyle } from "./shared";
import type { UtilityInfoState, SplatUtilityResponse } from "./types";
import { UtilityInfoCardEdit } from "./UtilityInfoCardEdit";

const UtilityInfoCard = ({
  initialUtilityData,
  onUtilityInfoSave,
  onCancel,
  utilityCompanies,
  hasActiveProposal,
}: UtilityInfoCardProps) => {
  const [isEdit, setIsEdit] = useState(false);

  const handleSave = (selectedUtility: UtilityInfoState) => {
    onUtilityInfoSave(selectedUtility);
    setIsEdit(false);
  };

  return (
    <CardStyled dataTestId="utility-info-card-container">
      <CardHeader
        title="Utility Information"
        rightContent={
          <>
            <UnderlinedButtonStyle
              size="xs"
              color="tertiary"
              onClick={() => setIsEdit(true)}
              style={{ visibility: !isEdit ? "visible" : "hidden" }}
              data-testid="utility-info-edit"
            >
              Edit
            </UnderlinedButtonStyle>
          </>
        }
      />
      {!isEdit && (
        <CardStyledInformationContent
          fields={[
            {
              title: "Utility company",
              value: initialUtilityData.utilityCompany || "-",
            },
            {
              title: "Rate schedule",
              value: initialUtilityData.rateSchedule || "-",
            },
            {
              title: "Account number",
              value: initialUtilityData.accountNumber || "-",
            },
            {
              title: "Meter number",
              value: initialUtilityData.meterNumber || "-",
            },
            {
              title: "Utility service address",
              value: initialUtilityData.utilityServiceAddress || "-",
            },
            {
              title: "Date of latest utility bill",
              value: initialUtilityData.utilityBillDate || "-",
            },
          ]}
        />
      )}
      {isEdit && (
        <UtilityInfoCardEdit
          initialUtilityData={initialUtilityData}
          utilityCompanies={utilityCompanies || []}
          onCancel={() => {
            setIsEdit(false);
            onCancel();
          }}
          onUtilityInfoSave={handleSave}
          hasActiveProposal={hasActiveProposal}
        />
      )}
    </CardStyled>
  );
};

interface UtilityInfoCardProps {
  initialUtilityData: UtilityInfoState;
  onUtilityInfoSave: (selectedUtility: UtilityInfoState) => void;
  onCancel: () => void;
  utilityCompanies: SplatUtilityResponse[];
  hasActiveProposal: boolean;
}

const CardStyled = styled(Card)`
  margin: 40px 0px 40px 0px;
  .modal-wrapper {
    padding: 0;
    margin: 0;
  }
`;

export { UtilityInfoCard, UtilityInfoState };
export type { UtilityInfoCardProps };
